export const API_URL = process.env.VUE_APP_API_URI;
export default API_URL;
